import mpWxEvtHandle from './mpWx';
import webHandle from './web';

export const mpWxEvent = {
  ...mpWxEvtHandle,
};

export const webEvent = {
  ...webHandle,
};

const eventHandle = {
  mpWxEvent,
  webEvent,
};

export default eventHandle;
